'use client';

import { useNotificationAlerts } from '../hooks/use-notification-alerts';

/**
 * Componenta-pacaleala: monteaza hook-ul global de alerte si nu randeaza nimic.
 * Inserata o singura data in (dashboard)/layout.tsx.
 */
export function NotificationAlertsMount() {
  useNotificationAlerts();
  return null;
}
